/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S5_IntroInputs */

const tr_cerez_s5_intro = /** @type {(inputs: Cerez_S5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform altyapımızda yer alan üçüncü taraflar:`)
};

const en_cerez_s5_intro = /** @type {(inputs: Cerez_S5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Third parties that are part of our platform infrastructure:`)
};

const de_cerez_s5_intro = /** @type {(inputs: Cerez_S5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dritte, die Teil unserer Plattform-Infrastruktur sind:`)
};

const ru_cerez_s5_intro = /** @type {(inputs: Cerez_S5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Третьи лица, входящие в инфраструктуру нашей Платформы:`)
};

/**
* | output |
* | --- |
* | "Third parties that are part of our platform infrastructure:" |
*
* @param {Cerez_S5_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s5_intro = /** @type {((inputs?: Cerez_S5_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S5_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s5_intro(inputs)
	if (locale === "de") return de_cerez_s5_intro(inputs)
	if (locale === "ru") return ru_cerez_s5_intro(inputs)
	return tr_cerez_s5_intro(inputs)
});